<template>
  <div id="print-report">
    <!-- 버튼 리스트 -->
    <vs-row v-if="isSuperUser && !isPrint">
      <vs-col v-if="editMode" vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h4>급박한 위험 또는 중대재해 발생시 비상대비 매뉴얼</h4>
        <div class="mb-4 ml-auto">
          <vs-button class="ml-4" color="secondary" type="border" @click="onClickReturn">기본값으로 초기화</vs-button>
          <vs-button class="ml-4" color="secondary" @click="onClickSave">저장</vs-button>
        </div>
      </vs-col>
      <vs-col v-else vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h4>급박한 위험 또는 중대재해 발생시 비상대비 매뉴얼</h4>
        <div class="mb-4 ml-auto">
          <vs-button class="ml-4" color="secondary" type="border" @click="onClickPrint">인쇄</vs-button>
          <vs-button class="ml-4" color="secondary" @click="onClickEdit">편집</vs-button>
        </div>
      </vs-col>
    </vs-row>
    <vs-row class="my-2">
      <p>※ 작업중지권: 근로자 등 종사자, 관리감독자, 사업주, 고용노동부 모두 행사 가능</p>
    </vs-row>

    <!-- 첫번째 색션 -->
    <div class="mt-2">
      <h5 class="my-3"><i class="dot"></i>1. 급박한 위험이 있는 경우</h5>
      <div class="grid border-top border-left" style="grid-template-columns: 1fr 1fr 1fr 1fr;">
        <div class="border-right border-bottom">
          <p class="thead py-2 border-bottom">상황 접수</p>
          <div class="p-2">
            <ml-textarea v-if="editMode" class="w-full m-0" v-model="form.급박한위험이있는경우.상황접수" rows="3"/>
            <div v-else style="min-height: 64px; white-space: pre-wrap">{{ form.급박한위험이있는경우.상황접수 }}</div>
          </div>
        </div>
        <div class="border-right border-bottom">
          <p class="thead py-2 border-bottom">상황전파</p>
          <div class="p-2">
            <ml-textarea v-if="editMode" class="w-full m-0" v-model="form.급박한위험이있는경우.상황전파" rows="3"/>
            <div v-else style="min-height: 64px; white-space: pre-wrap">{{ form.급박한위험이있는경우.상황전파 }}</div>
          </div>
        </div>
        <div class="border-right border-bottom">
          <p class="thead py-2 border-bottom">상황 대응</p>
          <div class="p-2">
            <ml-textarea v-if="editMode" class="w-full m-0" v-model="form.급박한위험이있는경우.상황대응" rows="3"/>
            <div v-else style="min-height: 64px; white-space: pre-wrap">{{ form.급박한위험이있는경우.상황대응 }}</div>
          </div>
        </div>
        <div class="border-right border-bottom">
          <p class="thead py-2 border-bottom">조치결과보고</p>
          <div class="p-2">
            <ml-textarea v-if="editMode" class="w-full m-0" v-model="form.급박한위험이있는경우.조치결과보고" rows="3"/>
            <div v-else style="min-height: 64px; white-space: pre-wrap">{{ form.급박한위험이있는경우.조치결과보고 }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 두번째 색션 -->
    <vs-row class="mt-8 mb-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i>1-1. 대응절차</h5>
        <div v-if="editMode" class="ml-auto">
          <vs-button color="secondary" @click="addRow('급박한위험이있는경우_대응절차')"> 항목추가 </vs-button>
          <vs-button color="secondary" type="border" class="ml-2" @click="deleteRow('급박한위험이있는경우_대응절차')"> 선택삭제 </vs-button>
        </div>
      </vs-col>
    </vs-row>
    <div class="border-top border-left">
      <div class="section_1-1 border-bottom" :class="editMode ? 'editMode' : ''">
        <div v-if="editMode" class="thead head border-right flex justify-center"><vs-checkbox class="m-0 p-0"></vs-checkbox></div>
        <div class="thead head border-right">상황 단계</div>
        <div class="thead head border-right">조치내용</div>
        <div class="thead head border-right">수행</div>
      </div>
      <draggable class="w-full" :list="form.급박한위험이있는경우_대응절차" handle=".handle">
        <div
          class="w-full section_1-1 row-content border-bottom"
          :class="editMode ? 'editMode' : ''"
          v-for="(rows, indexRows) in form.급박한위험이있는경우_대응절차"
          :key="indexRows"
        >
          <div v-if="editMode" class="h-full border-right flex items-center justify-center">
            <feather-icon class="handle mr-4 ml-2" icon="MenuIcon" style="width: 14px; height: 14px; cursor: pointer" />
            <vs-checkbox class="m-0 p-0" v-model="rows.is_checked"></vs-checkbox>
          </div>

          <!-- 상황 단계 -->
          <div class="h-full border-right text-center" :class="{'p-2':editMode}">
            <ml-textarea v-if="editMode" class="h-full w-full m-0" v-model="rows.상황단계" rows="3"/>
            <div v-else class="thead h-full p-2" style="min-height: 64px; white-space: pre-wrap">{{ rows.상황단계 }}</div>
          </div>

          <!-- 조치내용 -->
          <div class="h-full p-2 border-right">
            <ml-textarea v-if="editMode" class="w-full m-0" v-model="rows.조치내용" rows="3"/>
            <div v-else class="p-2" style="min-height: 64px; white-space: pre-wrap">{{ rows.조치내용 }}</div>
          </div>

          <!-- 수행 -->
          <div class="h-full p-2 border-right">
            <ml-textarea v-if="editMode" class="w-full m-0" v-model="rows.수행" rows="3"/>
            <div v-else class="p-2" style="min-height: 64px; white-space: pre-wrap">{{ rows.수행 }}</div>
          </div>

        </div>
      </draggable>
    </div>

    <!-- 세번째 색션 -->
    <div class="mt-8">
      <h5 class="my-3"><i class="dot"></i>2. 재해발생시(상황에 맞게 변경)</h5>
      <div class="grid border-top border-left" style="grid-template-columns: 1fr 1fr 1fr 1fr;">
        <div class="border-right border-bottom">
          <p class="thead py-2 border-bottom">상황 접수</p>
          <div class="p-2">
            <ml-textarea v-if="editMode" class="w-full m-0" v-model="form.재해발생시.상황접수" rows="3"/>
            <div v-else style="min-height: 64px; white-space: pre-wrap">{{ form.재해발생시.상황접수 }}</div>
          </div>
        </div>
        <div class="border-right border-bottom">
          <p class="thead py-2 border-bottom" >상황전파</p>
          <div class="p-2">
            <ml-textarea v-if="editMode" class="w-full m-0" v-model="form.재해발생시.상황전파" rows="3"/>
            <div v-else style="min-height: 64px; white-space: pre-wrap">{{ form.재해발생시.상황전파 }}</div>
          </div>
        </div>
        <div class="border-right border-bottom">
          <p class="thead py-2 border-bottom" >상황 대응</p>
          <div class="p-2">
            <ml-textarea v-if="editMode" class="w-full m-0" v-model="form.재해발생시.상황대응" rows="3"/>
            <div v-else style="min-height: 64px; white-space: pre-wrap">{{ form.재해발생시.상황대응 }}</div>
          </div>
        </div>
        <div class="border-right border-bottom">
          <p class="thead  py-2 border-bottom" >조치결과보고</p>
          <div class="p-2">
            <ml-textarea v-if="editMode" class="w-full m-0" v-model="form.재해발생시.조치결과보고" rows="3"/>
            <div v-else style="min-height: 64px; white-space: pre-wrap">{{ form.재해발생시.조치결과보고 }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 네번째 색션 -->
    <vs-row class="mt-8 mb-4">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i>2-1. 대응절차</h5>
        <div v-if="editMode" class="ml-auto">
          <vs-button color="secondary" @click="addRow('재해발생시_대응절차')"> 항목추가 </vs-button>
          <vs-button color="secondary" type="border" class="ml-2" @click="deleteRow('재해발생시_대응절차')"> 선택삭제 </vs-button>
        </div>
      </vs-col>
    </vs-row>
    <div class="border-top border-left">
      <div class="section_1-1 border-bottom" :class="editMode ? 'editMode' : ''">
        <div v-if="editMode" class="thead head border-right flex justify-center"><vs-checkbox class="m-0 p-0"></vs-checkbox></div>
        <div class="thead head border-right">상황 단계</div>
        <div class="thead head border-right">조치내용</div>
        <div class="thead head border-right">수행</div>
      </div>
      <draggable class="w-full" :list="form.재해발생시_대응절차" handle=".handle">
        <div
          class="w-full section_1-1 row-content border-bottom"
          :class="editMode ? 'editMode' : ''"
          v-for="(rows, indexRows) in form.재해발생시_대응절차"
          :key="indexRows"
        >
          <div v-if="editMode" class="h-full border-right flex items-center justify-center">
            <feather-icon class="handle mr-4 ml-2" icon="MenuIcon" style="width: 14px; height: 14px; cursor: pointer" />
            <vs-checkbox class="m-0 p-0" v-model="rows.is_checked"></vs-checkbox>
          </div>

          <!-- 상황 단계 -->
          <div class="h-full border-right text-center" :class="{'p-2':editMode}">
            <ml-textarea v-if="editMode" class="h-full w-full m-0" v-model="rows.상황단계" rows="3"/>
            <div v-else class="thead h-full " style="min-height: 64px; white-space: pre-wrap">{{ rows.상황단계 }}</div>
          </div>

          <!-- 조치내용 -->
          <div class="h-full p-2 border-right">
            <ml-textarea v-if="editMode" class="w-full m-0" v-model="rows.조치내용" rows="3"/>
            <div v-else class="p-2" style="min-height: 64px; white-space: pre-wrap">{{ rows.조치내용 }}</div>
          </div>

          <!-- 수행 -->
          <div class="h-full p-2 border-right">
            <ml-textarea v-if="editMode" class="w-full m-0" v-model="rows.수행" rows="3"/>
            <div v-else class="p-2" style="min-height: 64px; white-space: pre-wrap">{{ rows.수행 }}</div>
          </div>

        </div>
      </draggable>
    </div>

  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader.vue";
import draggable from "vuedraggable";
import SignField from '@/components/SignField.vue'

export default {
  components: {
    SignField,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    draggable,
  },
  props: {
    board: Object,
    value: Object,
  },
  computed: {
    isSuperUser() {
      return !!this.myInfo.is_superuser;
    },
    myInfo() {
      return this.$store.state.auth.userInfo;
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    list() {
      return this.$store.state.board.postListInfo.data;
    },
    default_급박한위험이있는경우() {
      return {
        상황접수: '최초발견자 신고\n\n작업중지권',
        상황전파: '관리감독자(교육장) → 비상조치반\n\n종사자 안전보건 확보조치',
        상황대응: '유해·위험요소 확인\n안전조치\n추가피해방지 조치',
        조치결과보고: '위험요소 부문\n\n동향보고, 조치결과보고',
      }
    },
    default_급박한위험이있는경우_대응절차() {
      return [
        {
          is_checked: false,
          상황단계: "급박한\n유해·위험요소발견\n(유해·위험요소 신고)",
          조치내용: "작업중지 및 관리감독자에게 신고\n◾발견자 → 관리감독자, 119\n작업중지권 행사, 응급조치, 종사자 대피\n재해발생 전파",
          수행: "유해·위험요소 발견자\n작업중지권 행사\n전파"
        },
        {
          is_checked: false,
          상황단계: "유해·위험요소\n확인 및 제거",
          조치내용: "관리감독자 및 비상조치반 현장 이동\n" +
            "◾근로자 대피(작업중지)확인\n" +
            "◾유해·위험요소 확인\n" +
            "◾종사자 안전보건 확보\n" +
            "◾위험요인 제거\n" +
            "◾추가피해방지 조치",
          수행: "종사자대피\n" +
            "현장통제\n" +
            "위험요인 제거 등"
        },
        {
          is_checked: false,
          상황단계: "안전확인",
          조치내용: "유해·위험요소 안전조치 확인",
          수행: "관리감독자\n" +
            "종사자"
        },
        {
          is_checked: false,
          상황단계: "작업재개",
          조치내용: "유해·위험요소 안전조치 확인",
          수행: "관리감독자\n" +
            "종사자"
        },
        {
          is_checked: false,
          상황단계: "결과보고",
          조치내용: "동향보고 및 조치결과보고서 작성\n" +
            "위험성 평가 실시",
          수행: "위험요소 부문"
        },


      ]
    },
    default_재해발생시() {
      return {
        상황접수: '최초발견자 신고\n\n작업중지권',
        상황전파: '관리감독자(교육장) → 비상조치반\n\n종사자 안전보건확보조치\n고용노동부, 본청(안전담당관 및 해당 사업부서)에 지체없이 보고',
        상황대응: '재해자 이송\n종사자 대피 확인\n유해·위험요소제거\n추가피해방지 조치',
        조치결과보고: '위험요소 부문\n\n원인조사 등\n재발방지계획 수립\n산업재해조사표제출위험성평가 등 실시\n기록보존',
      }
    },
    default_재해발생시_대응절차() {
      return [
        {
          is_checked: false,
          상황단계: "재해발생",
          조치내용: "작업중지 후 관리감독자에게 신고·119신고\n" +
            "◾발견자 → 관리감독자, 119\n" +
            "작업중지권 행사, 응급조치, 종사자 대피\n" +
            "재해발생 전파, 고용노동부 등 지체없이 보고",
          수행: "재해발견 근로자\n" +
            "작업중지권 행사\n" +
            "전파 등"
        },
        {
          is_checked: false,
          상황단계: "대응 구조\n" +
            "*작업중지, 종사자대피\n" +
            "위험요소 확인 등",
          조치내용: "[사망] 관리감독자 및 비상조치반 현장 이동\n" +
            "  ◾재해자 안전장소 이동, 작업중지\n" +
            "  ◾종사자 대피 등 안전보건 확보\n" +
            "  ◾유가족에게 알림\n" +
            "  ◾그외 부상자 발생 조치와 같음",
          수행: "초동대처\n" +
            "종사자 대피\n" +
            "현장통제 등"
        },
        {
          is_checked: false,
          상황단계: "안전확인",
          조치내용: "유해·위험요소 안전조치 확인",
          수행: "관리감독자\n" +
            "종사자"
        },
        {
          is_checked: false,
          상황단계: "''",
          조치내용: "[부상] 관리감독자 및 비상조치반 현장 이동\n" +
            "  ◾재해자 구출\n" +
            "      ⦁ 응급처치 등(응급조치 물품 확인)\n" +
            "  ◾종사자 대피 등 안전보건 확보\n" +
            "      ⦁초동조치: 초기진화, 2차 피해방지",
          수행: "초동대처\n" +
            "응급기관 안내 유도\n" +
            "종사자 대피\n" +
            "현장통제 등"
        },
        {
          is_checked: false,
          상황단계: "유해·위험요인제거",
          조치내용: "안전조치 실시 및 추가피해 방지\n" +
            "◾유해·위험 요인 제거 작업",
          수행: "전문기관 등"
        },
        {
          is_checked: false,
          상황단계: "작업재개",
          조치내용: "[사망] ⦁재해자 이송 병원 방문 등\n" +
            "[부상] ⦁관리감독자 및 종사자 안전 확인 후 재개",
          수행: "관리감독자 등"
        },
        {
          is_checked: false,
          상황단계: "결과보고",
          조치내용: "원인조사, 재발방지계획 수립 등\n" +
            "산업재해조사표 제출\n" +
            "위험성평가, 근골격계질환조사 등",
          수행: "위험요소 부문 예방"
        },
      ]
    },
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler(/*value*/) {},
    },
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    list(list) {
      if (list.length > 0) {
        const data = JSON.parse(list[0].post_content);
        this.form = data.body;
      }
    },
  },
  async mounted() {
    this.initForm();
    await this.loadListBoard();
  },
  data() {
    return {
      isPrint: false,
      editMode: false,
      form: {
        급박한위험이있는경우: {
          상황접수: '',
          상황전파: '',
          상황대응: '',
          조치결과보고: '',
        },
        급박한위험이있는경우_대응절차: [],
        재해발생시: {
          상황접수: '',
          상황전파: '',
          상황대응: '',
          조치결과보고: '',
        },
        재해발생시_대응절차: [],
      },
    };
  },
  methods: {
    initForm() {
      this.form.급박한위험이있는경우 = JSON.parse(JSON.stringify(this.default_급박한위험이있는경우));
      this.form.급박한위험이있는경우_대응절차 = JSON.parse(JSON.stringify(this.default_급박한위험이있는경우_대응절차));
      this.form.재해발생시 = JSON.parse(JSON.stringify(this.default_재해발생시));
      this.form.재해발생시_대응절차 = JSON.parse(JSON.stringify(this.default_재해발생시_대응절차));
    },
    onClickReturn() {
      this.initForm();
    },
    printLandscape() {
      this.print("@media print {@page { size: a3 landscape; }}");
    },
    printPortrait() {
      this.print("@media print {@page { size: a3 portrait; }}");
    },
    print(css) {
      this.isPrint = true;
      setTimeout(() => {
        const printTextarea = document.getElementsByClassName("print-textarea");
        for (let i = 0; i < printTextarea.length; i++) {
          const pt_r = printTextarea[i].innerHTML.trimStart().trimEnd().replace(/\r\n/gi, "<br>").replace(/\\n/gi, "<br>").replace(/\n/gi, "<br>");

          document.getElementsByClassName("print-textarea")[i].innerHTML = pt_r;
        }

        const g_label = document.getElementById("print-label") ? document.getElementById("print-label").innerHTML : "";
        const g_oBeforeBody = document.getElementById("print-report").innerHTML;

        // 프린트를 보이는 그대로 나오기위한 셋팅
        window.onbeforeprint = function () {
          document.body.style.backgroundColor = "#fff";
          document.body.innerHTML = "";
          if (g_label) {
            document.body.innerHTML += `${g_label}<br>`;
          }
          document.body.innerHTML += g_oBeforeBody;
        };

        const head = document.head || document.getElementsByTagName("head")[0],
          style = document.createElement("style");

        style.type = "text/css";
        style.media = "print";

        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }

        head.appendChild(style);

        window.print();
        location.reload();
      }, 300);
    },
    onClickPrint() {
      const customAlert = new CustomEvent("customAlert", {
        detail: {
          title: "레이아웃 선택",
          messageIcon: "AlertCircleIcon",
          message: "인쇄 방향을 선택해 주세요.",
          useConfirm: true,
          confirmBtn: "세로 방향",
          cancelBtn: "가로 방향",
          confirmFunction: () => this.printPortrait(),
          cancelFunction: () => this.printLandscape(),
          size: "small",
          btnPosition: "center",
          confirmBtnStyle: {
            type: "border",
            icon: { type: "image", name: "icon-print-layout-vertical.svg" },
            style: "",
          },
          cancelBtnStyle: {
            type: "border",
            icon: { type: "image", name: "icon-print-layout-horizontal.svg" },
            style: "",
          },
        },
      });
      window.dispatchEvent(customAlert);
    },
    onClickMoveList() {
      this.$router.back();
    },
    onClickEdit () {
      this.editMode = true;
    },
    onClickSave() {
      this.editMode = false;
      if (this.list && this.list.length > 0) {
        this.saveBoardPost("update");
      } else {
        this.saveBoardPost("create");
      }
    },
    addRow(form_key) {
      this.form[form_key].push({ is_checked: false, 상황단계: "", 조치내용: "", 수행: "" });
    },
    deleteRow(form_key) {
      for (let i = 0; i< this.form[form_key].length; i++) {
        if (this.form[form_key][i].is_checked) {
          this.form[form_key].splice(i, 1);
          i--;
        }
      }
    },
    async loadListBoard() {
      const boardId = this.boardId;
      const page = 1;
      const perPage = 5;
      await this.$store.dispatch("board/LOAD_POST_LIST", {
        projectId: this.projectId,
        boardId,
        page,
        perPage,
      });
    },
    async saveBoardPost(type) {
      const form = {
        header: {
          full: new Date().format("yyyy-MM-dd"),
          month: new Date().getMonth() + 1,
          year: new Date().getFullYear(),
        },
        body: this.form,
        summary: {},
      };

      const projectId = this.projectId;
      const boardId = this.boardId;
      const title = "산업재해 발생 시 보고 절차 안내";
      const content = JSON.stringify(form);

      if (type === "create") {
        await this.$store.dispatch("board/CREATE_POST", {
          projectId,
          boardId,
          title,
          content,
        });
      } else if (type === "update") {
        const postId = this.list[0].id;
        await this.$store.dispatch("board/UPDATE_POST", {
          projectId,
          boardId,
          postId,
          title,
          content,
        });
      }
      this.oldForm = JSON.parse(JSON.stringify(this.form));
      this.loadListBoard();
    },
  },
};
</script>

<style lang="scss" scoped>
.section_1-1 {
  display: grid;
  grid-template-columns: 200px 1fr 260px;
  justify-content: center;
  align-items: center;

  & > .head {
    padding: 10px;
    text-align: center;
  }

  &.editMode {
    grid-template-columns: 74px 200px 1fr 260px;
  }
}
.thead {
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  background-color: #F9F9F9;
}
</style>
